import styled from 'styled-components'

export const Container = styled.div`
  background: #FFFFFF;
  border: 2px solid #CED8D8;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 12px;

  svg {
    min-width: 26.5px;
    min-height: 26.5px;
    color: #C8C8C8;
  }

  input {
    width: 100%;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #353744;
    border: none;
  }
`